/* eslint-disable import/order */
import React from 'react';
import './_HeaderIconButton.sass';
import IconArrowLeft from '@pano-project/assets/icons/icon-arrow-left';
import IconHeaderClose from '@pano-project/assets/icons/icon-header-close';

export type HeaderIconButtonVariant = 'back' | 'close';

interface HeaderIconButtonProps {
  variant: HeaderIconButtonVariant;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
  iconColor?: string;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  variant,
  onClick,
  disabled = false,
  ariaLabel,
  className = '',
  iconColor,
  buttonRef,
}) => {
  const Icon = variant === 'back' ? IconArrowLeft : IconHeaderClose;

  return (
    <button
      type="button"
      ref={buttonRef}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel ?? (variant === 'back' ? 'back' : 'close')}
      className={`header-icon-button${className ? ` ${className}` : ''}`}
    >
      <Icon color={iconColor} />
    </button>
  );
};

export default HeaderIconButton;
